import { Fragment, ReactNode } from "react";
import { Dialog, Transition } from "@headlessui/react";
import classNames from "classnames";

type Props = {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  position: "left" | "right" | "top" | "bottom";
};

export const Drawer = ({ open, onClose, children, position }: Props) => {
  return (
    <Transition show={open} as={Fragment}>
      <Dialog onClose={onClose} className="relative z-10">
        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div
              className={classNames(
                "pointer-events-none fixed flex max-w-full",
                {
                  "inset-y-0 right-0 pl-10": position === "right",
                  "inset-y-0 left-0 pr-10": position === "left",
                  "inset-x-0 top-0 pb-10": position === "top",
                  "inset-x-0 bottom-0 pt-10": position === "bottom",
                }
              )}
            >
              <Transition.Child
                as={Fragment}
                enter="transition ease-in-out duration-500 transform"
                enterFrom={classNames({
                  "translate-x-full": position === "right",
                  "-translate-x-full": position === "left",
                  "translate-y-full": position === "bottom",
                  "-translate-y-full": position === "top",
                })}
                enterTo={classNames({
                  "-translate-x-0": position === "right",
                  "translate-x-0": position === "left",
                  "translate-y-0": position === "bottom",
                  "-translate-y-0": position === "top",
                })}
                leave="transition ease-in-out duration-500 transform"
                leaveFrom={classNames({
                  "-translate-x-0": position === "right",
                  "translate-x-0": position === "left",
                  "translate-y-0": position === "bottom",
                  "-translate-y-0": position === "top",
                })}
                leaveTo={classNames({
                  "translate-x-full": position === "right",
                  "-translate-x-full": position === "left",
                  "translate-y-full": position === "bottom",
                  "-translate-y-full": position === "top",
                })}
              >
                <Dialog.Panel className="pointer-events-auto relative">
                  <div
                    className="h-full overflow-y-auto"
                    onMouseLeave={onClose}
                  >
                    {children}
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};